var map = {
	"./01_logo.svg": 18172,
	"./02_logo.svg": 39523,
	"./03_logo.svg": 64587,
	"./Beta_Icon.svg": 77074,
	"./Button_Close.png": 50522,
	"./Canvas_normal2.png": 91861,
	"./Checked_Normal.png": 80111,
	"./Clothes_Hover.png": 74747,
	"./Clothes_Press.png": 99586,
	"./Clothes_normal.png": 28329,
	"./Clothing charts_normal.png": 17253,
	"./Clothing_Selected.png": 47712,
	"./Clothing_normal.png": 22302,
	"./Commodity_Tips.svg": 10725,
	"./Decorate_1.png": 22648,
	"./Decorate_2.png": 92931,
	"./Decorate_3.png": 83433,
	"./Decorate_4.png": 21966,
	"./Decorate_dressform.png": 84375,
	"./Decorate_model.png": 13014,
	"./Decorate_tryon.png": 36847,
	"./Edit_Normal.png": 2293,
	"./Event pop-ups2.svg": 1774,
	"./Exclamation point.png": 17405,
	"./Exclamation point.svg": 20159,
	"./Figure1.png": 3614,
	"./Figure1_blur.png": 63039,
	"./Figure2.png": 63195,
	"./Figure2_blur.png": 38265,
	"./Figure3.png": 93340,
	"./Figure3_blur.png": 60640,
	"./Find.png": 4709,
	"./Frame 746.png": 92538,
	"./Frame 964.svg": 46868,
	"./Frame 965.svg": 91120,
	"./Group 130.jpg": 44280,
	"./Group 130.png": 36487,
	"./Group 408 (1).svg": 90586,
	"./Group 408.svg": 296,
	"./HD Preview.svg": 15674,
	"./IconCompare.svg": 27135,
	"./IconCompareActived.svg": 40939,
	"./Intelligent Lighting_normat.png": 60958,
	"./LOGO.png": 98297,
	"./Left_Switch.svg": 16348,
	"./Member_01.svg": 18299,
	"./Member_02.svg": 84425,
	"./Member_03.svg": 7765,
	"./Member_04.svg": 19159,
	"./Member_Specific_Popover.svg": 7701,
	"./Menu bar_Adjustment_normat.png": 8322,
	"./Menu bar_Beautification_normat.png": 50363,
	"./Menu bar_Deformation_Selected.svg": 73934,
	"./Menu bar_Deformation_hover.png": 42769,
	"./Menu bar_Deformation_normat.png": 50366,
	"./Menu bar_Edit_Add_hover.png": 44267,
	"./Menu bar_Edit_Add_normat.png": 56674,
	"./Menu bar_Erase_hover.png": 27983,
	"./Menu bar_Erase_normat.png": 33695,
	"./Menu bar_Erase_normat.svg": 12565,
	"./Menu bar_Generate_disable (1).png": 16798,
	"./Menu bar_Generate_disable.png": 91704,
	"./Menu bar_Generate_hover (1).png": 30024,
	"./Menu bar_Generate_hover.png": 43598,
	"./Menu bar_Generate_normal (1).png": 68201,
	"./Menu bar_Generate_normal (2).png": 40022,
	"./Menu bar_Generate_normal.png": 93607,
	"./Menu bar_Generate_normat (1).png": 94689,
	"./Menu bar_Generate_normat.png": 6701,
	"./Menu bar_Generate_normat_gray.png": 3146,
	"./Menu bar_Generate_selected (1).png": 78552,
	"./Menu bar_Generate_selected.png": 85502,
	"./Menu bar_HD_hover.png": 82791,
	"./Menu bar_HD_normat.png": 10336,
	"./Menu bar_HD_normat.svg": 71451,
	"./Menu bar_Keying_Selected.png": 96419,
	"./Menu bar_Keying_normat (1).png": 72769,
	"./Menu bar_Keying_normat (1).svg": 24929,
	"./Menu bar_Keying_normat (2).svg": 75689,
	"./Menu bar_Keying_normat.png": 96667,
	"./Menu bar_Keying_normat.svg": 11717,
	"./Menu bar_Keying_normat2.png": 30744,
	"./Merchandise_Hover.png": 82522,
	"./Merchandise_Press.png": 82055,
	"./Merchandise_normal.png": 61537,
	"./Multiple Clothing (1).png": 62192,
	"./Multiple Clothing.png": 87387,
	"./Musk.png": 71257,
	"./People_Selected.png": 77022,
	"./Personal Center_Energy_Tag.svg": 97858,
	"./PhotoStudio AI.png": 35216,
	"./Point.png": 15546,
	"./Power_Icon.svg": 49262,
	"./Random model.png": 5403,
	"./Real_Normal.png": 38840,
	"./Real_Selected.png": 80513,
	"./Rectangle 237 (1).svg": 24793,
	"./Rectangle 237.svg": 75085,
	"./Rectangle 272.svg": 38932,
	"./Remove_Normal.svg": 88068,
	"./Remove_Press.svg": 91697,
	"./Remove_hover.svg": 86715,
	"./Right_Switch.svg": 21150,
	"./Set_Background_Normal.png": 73528,
	"./VIP_Crown.svg": 33545,
	"./Vector.svg": 78994,
	"./accurate.png": 99727,
	"./activity_bg.png": 72940,
	"./aieditor.svg": 64640,
	"./aieditor_dark.svg": 3371,
	"./aieditor_dark_hover.svg": 60883,
	"./aieditor_dark_press.svg": 10540,
	"./aieditor_hover.svg": 83005,
	"./aieditor_press.svg": 54682,
	"./alipay_placeholder.png": 21929,
	"./arcbean.png": 14694,
	"./arcbean2.png": 67371,
	"./arcbean3.png": 25994,
	"./arcbean3.svg": 67072,
	"./arcbean3_disbaled.png": 17335,
	"./arcbean3_disbaled.svg": 24106,
	"./arcbean4.svg": 1614,
	"./benner01.png": 69167,
	"./beta test.png": 35399,
	"./bg.png": 74145,
	"./bookmark.svg": 96608,
	"./bookmark_checked.svg": 82931,
	"./bookmark_checked_dark.svg": 85548,
	"./bookmark_checked_dark_hover.svg": 53236,
	"./bookmark_checked_dark_press.svg": 7373,
	"./bookmark_checked_hover.svg": 1995,
	"./bookmark_checked_press.svg": 70393,
	"./bookmark_dark.svg": 10673,
	"./bookmark_dark_hover.svg": 28380,
	"./bookmark_dark_press.svg": 60570,
	"./bookmark_hover.svg": 65873,
	"./bookmark_press.svg": 83893,
	"./button.svg": 21275,
	"./circle_1.png": 78876,
	"./circle_2.png": 64319,
	"./collapseIcon.png": 97364,
	"./complete.png": 23189,
	"./coupon_after.svg": 16199,
	"./coupon_before.svg": 55824,
	"./coupon_card.svg": 1203,
	"./datepicker_icon.png": 88947,
	"./deleteIcon.png": 54816,
	"./deliveryend.png": 50124,
	"./deliveryps.png": 62457,
	"./deliveryps2.png": 17386,
	"./ditu.png": 24466,
	"./down_conner.svg": 14433,
	"./download.svg": 23694,
	"./download_dark.svg": 47796,
	"./download_dark_hover.svg": 20742,
	"./download_dark_press.svg": 29358,
	"./download_hover.svg": 72271,
	"./download_press.svg": 70318,
	"./editIcon/cloth.svg": 32949,
	"./editIcon/clothactive.svg": 9510,
	"./editIcon/dress.svg": 47995,
	"./editIcon/dressactive.svg": 23326,
	"./editIcon/pants.svg": 39774,
	"./editIcon/pantsactive.svg": 25403,
	"./effect@2x.png": 98839,
	"./end_corner.svg": 77626,
	"./energy point (2).png": 77943,
	"./energy point.png": 16685,
	"./energy point.svg": 7361,
	"./energy_point.png": 48774,
	"./energy_point_hover.png": 68382,
	"./expectation_normal.png": 17009,
	"./extraction/Musk.png": 65978,
	"./extraction/help.png": 27121,
	"./extraction/icon_add.svg": 56835,
	"./extraction/icon_erase.svg": 10850,
	"./extraction/icon_erase_actived.svg": 33853,
	"./extraction/icon_paint.svg": 3526,
	"./extraction/icon_paint_actived.svg": 67773,
	"./extraction/icon_remove.svg": 35591,
	"./extraction/icon_reset.svg": 83508,
	"./extraction/icon_reset_actived.svg": 87947,
	"./extraction/icon_undo.svg": 8381,
	"./extraction/icon_undo_actived.svg": 31592,
	"./fallback.png": 99987,
	"./favorite_empty.svg": 47495,
	"./favorites.svg": 18759,
	"./favorites_checked.svg": 75389,
	"./favorites_press.svg": 74427,
	"./finshedps.png": 90625,
	"./flatten.png": 38910,
	"./frame01.png": 66562,
	"./frame_empty.png": 93512,
	"./front beat (1).png": 93604,
	"./front beat.png": 14225,
	"./generating.png": 85124,
	"./goeditbtn.png": 58257,
	"./goeditbtn.svg": 80417,
	"./goeditbtn1.png": 8602,
	"./goeditbtn2.png": 71583,
	"./gongan.png": 47187,
	"./guide_dressform_custom_scene.png": 68610,
	"./guide_dressform_scene_fragment.jpg": 41364,
	"./guide_dressform_scene_fragment.png": 95344,
	"./guide_model_custom_scene.png": 29977,
	"./guide_model_scene_fragment.png": 43063,
	"./guide_ref_img_same.png": 41830,
	"./guide_ref_img_samekind.png": 78048,
	"./guide_ref_img_similarity.png": 2185,
	"./home/icon_batch.svg": 84020,
	"./home/icon_free.svg": 52822,
	"./home/icon_gift.svg": 26005,
	"./home/icon_king.svg": 53240,
	"./home/icon_tab_beauty_normal.svg": 18650,
	"./home/icon_tab_beauty_pressed.svg": 16619,
	"./home/icon_tab_changebg_normal.svg": 33718,
	"./home/icon_tab_changebg_pressed.svg": 49041,
	"./home/icon_tab_changecloth_normal.svg": 74958,
	"./home/icon_tab_changecloth_pressed.svg": 26530,
	"./home/icon_tab_changecolor_normal.svg": 84701,
	"./home/icon_tab_changecolor_pressed.svg": 44547,
	"./home/icon_tab_changegoods_normal.svg": 25928,
	"./home/icon_tab_changegoods_pressed.svg": 6111,
	"./home/icon_tab_changetov_normal.svg": 96016,
	"./home/icon_tab_changetov_pressed.svg": 71083,
	"./home/icon_tab_eraser_normal.svg": 19943,
	"./home/icon_tab_eraser_pressed.svg": 96672,
	"./home/icon_tab_keying_normal.svg": 16743,
	"./home/icon_tab_keying_pressed.svg": 49236,
	"./home/icon_tab_relight_normal.svg": 42520,
	"./home/icon_tab_relight_pressed.svg": 75447,
	"./home/icon_tab_resize_normal.svg": 2365,
	"./home/icon_tab_resize_pressed.svg": 41341,
	"./home/icon_tab_shoes_normal.svg": 63082,
	"./home/icon_tab_shoes_pressed.svg": 61360,
	"./home/icon_video.svg": 11297,
	"./home32x/Thumbs.db": 11321,
	"./home32x/batchImahe_active.svg": 40404,
	"./home32x/batchImahe_normal.svg": 45013,
	"./home32x/glass_image_active.svg": 98095,
	"./home32x/glass_image_normal.svg": 61546,
	"./home32x/hp_cloth_active.svg": 188,
	"./home32x/hp_cloth_normal.svg": 17694,
	"./home32x/hp_cutout_active.svg": 18676,
	"./home32x/hp_cutout_normal.svg": 93301,
	"./home32x/hp_goodscolorchange_active.svg": 64487,
	"./home32x/hp_goodscolorchange_normal.svg": 63774,
	"./home32x/hp_goodsimage_active.svg": 57043,
	"./home32x/hp_goodsimage_normal.svg": 36836,
	"./home32x/hp_handrepair_active.svg": 14811,
	"./home32x/hp_handrepairnormal.svg": 32293,
	"./home32x/hp_image_active.svg": 96037,
	"./home32x/hp_image_normal.svg": 12855,
	"./home32x/hp_magiceraser_active.svg": 10252,
	"./home32x/hp_magiceraser_normal.svg": 1951,
	"./home32x/hp_model_active.svg": 25502,
	"./home32x/hp_model_normal.svg": 17881,
	"./home32x/hp_relight_active.svg": 67269,
	"./home32x/hp_relight_normal.svg": 47275,
	"./home32x/hp_resize_active.svg": 36829,
	"./home32x/hp_resize_normal.svg": 57643,
	"./home32x/hp_shoes_active.svg": 76729,
	"./home32x/hp_shoes_normal.svg": 26495,
	"./home32x/hp_smartbeauty_active.svg": 25995,
	"./home32x/hp_smartbeauty_normal.svg": 1785,
	"./home32x/hp_video_active.svg": 29639,
	"./home32x/hp_video_normal.svg": 93526,
	"./home32x/pose_image_active.svg": 48021,
	"./home32x/pose_image_normal.svg": 44443,
	"./home32x/sidebar_project_cloth_active.svg": 84642,
	"./home32x/sidebar_project_cloth_normal.svg": 33914,
	"./home32x/sidebar_project_edit_active.svg": 60042,
	"./home32x/sidebar_project_edit_normal.svg": 35335,
	"./home32x/sidebar_project_goods_active.svg": 57657,
	"./home32x/sidebar_project_goods_normal.svg": 92218,
	"./home32x/sim_image_active.svg": 46591,
	"./home32x/sim_image_normal.svg": 49902,
	"./home_img1_mobile@2x.png": 67149,
	"./home_img1_mobile@2x_blur.png": 27961,
	"./home_img2_mobile@2x.png": 36057,
	"./home_img3_mobile@2x.png": 33325,
	"./icom_VIP_ordinary.png": 25810,
	"./icom_VIP_platinum.png": 24015,
	"./icon1_projects.png": 56262,
	"./icon1_projects_actived.png": 86829,
	"./icon2_projects.png": 97733,
	"./icon2_projects_actived.png": 32660,
	"./icon_1628.png": 28774,
	"./icon_Arrows.png": 26806,
	"./icon_Avatar.png": 81469,
	"./icon_Avatar_2.png": 59039,
	"./icon_Body.png": 77174,
	"./icon_Body.svg": 45286,
	"./icon_Brush.png": 97638,
	"./icon_Brush_1.png": 56066,
	"./icon_Brush_Selected.png": 97317,
	"./icon_Brush_hover.png": 87881,
	"./icon_Color.png": 67874,
	"./icon_Completion.png": 33494,
	"./icon_Eraser.svg": 92863,
	"./icon_Face.svg": 74521,
	"./icon_Failed.png": 80481,
	"./icon_Finishing_Selected.png": 12428,
	"./icon_HD.png": 18373,
	"./icon_HD_hover.png": 48850,
	"./icon_History.png": 86452,
	"./icon_History_hover.png": 2528,
	"./icon_Identify_Normal.png": 40961,
	"./icon_Identify_hover.png": 44907,
	"./icon_Member_01.png": 90265,
	"./icon_Member_02.png": 51191,
	"./icon_Member_03.png": 44274,
	"./icon_Member_04.png": 81391,
	"./icon_New Project.png": 18843,
	"./icon_Number.png": 90424,
	"./icon_Password.png": 65481,
	"./icon_Product Images.png": 87386,
	"./icon_Redo.png": 13911,
	"./icon_Redo_Normal.png": 85331,
	"./icon_Redo_hover.png": 18991,
	"./icon_Reset Modify_normal.png": 827,
	"./icon_Reset_Modify_active.svg": 75154,
	"./icon_Reset_Modify_disabled.svg": 73631,
	"./icon_Reset_Modify_normal.svg": 66353,
	"./icon_SD.png": 20384,
	"./icon_SD_hover.png": 70423,
	"./icon_Start End.jpg": 7422,
	"./icon_Tap.png": 10290,
	"./icon_Tap_Normal.png": 54938,
	"./icon_Tap_Selected.png": 2961,
	"./icon_Tap_hover.png": 56621,
	"./icon_Tap_normal_1.png": 94376,
	"./icon_VIP.png": 5489,
	"./icon_VIP_hover.png": 68719,
	"./icon_Validation.png": 49867,
	"./icon_WeChat.png": 83316,
	"./icon_Withdraw.png": 46424,
	"./icon_Withdraw_Normal.png": 88632,
	"./icon_Withdraw_hover.png": 68444,
	"./icon_Withdrawal_active.svg": 33752,
	"./icon_Withdrawal_disabled.svg": 11424,
	"./icon_Withdrawal_normal.svg": 27579,
	"./icon_add.svg": 91857,
	"./icon_age group.png": 6909,
	"./icon_aiEditor.svg": 36095,
	"./icon_aiEditor_disabled.svg": 86802,
	"./icon_aiEditor_hover.svg": 64583,
	"./icon_aiEditor_press.svg": 14112,
	"./icon_aiedit.png": 96524,
	"./icon_aiedit_actived.png": 69850,
	"./icon_alipay.png": 13780,
	"./icon_alipay@2x.png": 20133,
	"./icon_beautify.svg": 80471,
	"./icon_beautify_actived.svg": 84662,
	"./icon_beautify_hover.svg": 84561,
	"./icon_before_and_after_active.svg": 32814,
	"./icon_before_and_after_disabled.svg": 23404,
	"./icon_before_and_after_normal.svg": 81317,
	"./icon_big_checkmark.svg": 39821,
	"./icon_bookmark.svg": 44944,
	"./icon_bookmark_disabled.svg": 82830,
	"./icon_bookmark_hover.svg": 42665,
	"./icon_bookmark_press.svg": 11587,
	"./icon_bookmarked.svg": 68499,
	"./icon_cashback.svg": 24017,
	"./icon_change_bg.svg": 11554,
	"./icon_change_bg_hover.svg": 84277,
	"./icon_change_bg_press.svg": 77109,
	"./icon_change_model.svg": 37715,
	"./icon_change_model_hover.svg": 85174,
	"./icon_change_model_press.svg": 65853,
	"./icon_check.png": 44170,
	"./icon_clone_hover@2x.png": 3169,
	"./icon_clone_normal@2x.png": 99334,
	"./icon_close.png": 4461,
	"./icon_clothes.png": 57490,
	"./icon_clothes_actived.png": 19053,
	"./icon_commodity.png": 18213,
	"./icon_commodity.svg": 94309,
	"./icon_commodity_actived.png": 21471,
	"./icon_commodity_recolor.png": 63835,
	"./icon_commodity_recolor_actived.png": 26827,
	"./icon_commodity_video.png": 84886,
	"./icon_commodity_video_actived.png": 7216,
	"./icon_compare.svg": 16472,
	"./icon_composition_hover.svg": 77079,
	"./icon_composition_normal.svg": 17658,
	"./icon_composition_selected.svg": 89023,
	"./icon_contactus_normal.svg": 80047,
	"./icon_contactus_selected.svg": 57998,
	"./icon_ctrl_key_z.svg": 91528,
	"./icon_cutout_hover.svg": 69845,
	"./icon_cutout_normat.svg": 504,
	"./icon_cutout_selected.svg": 97178,
	"./icon_delete.svg": 32150,
	"./icon_delete_hover.png": 1299,
	"./icon_delete_hover.svg": 38872,
	"./icon_delete_hover@2x.png": 32656,
	"./icon_delete_key.svg": 21074,
	"./icon_delete_normal.png": 21388,
	"./icon_delete_normal@2x.png": 57151,
	"./icon_delete_press.svg": 92412,
	"./icon_diminish.svg": 50033,
	"./icon_download.svg": 13106,
	"./icon_download_disabled.svg": 3356,
	"./icon_download_hover.svg": 24186,
	"./icon_download_press.svg": 13099,
	"./icon_dressform.png": 31508,
	"./icon_dressform_actived.png": 87825,
	"./icon_email.png": 54889,
	"./icon_erase.svg": 6099,
	"./icon_erase_actived.svg": 72541,
	"./icon_expired.svg": 77274,
	"./icon_extraction.svg": 42208,
	"./icon_extraction_delete.svg": 87362,
	"./icon_extraction_delete_hover.svg": 98199,
	"./icon_extraction_hover.svg": 68741,
	"./icon_feedback_normal.svg": 62583,
	"./icon_feedback_selected.svg": 77244,
	"./icon_flips_normal@2x.png": 53841,
	"./icon_gallery.png": 53006,
	"./icon_gallery.svg": 58385,
	"./icon_gallery2.svg": 27837,
	"./icon_gender.png": 52506,
	"./icon_help.svg": 1541,
	"./icon_help_actived.svg": 19826,
	"./icon_home_aiedit_beautify--actived.png": 36563,
	"./icon_home_aiedit_beautify.png": 94101,
	"./icon_home_aiedit_filllight--actived.png": 3626,
	"./icon_home_aiedit_filllight.png": 31384,
	"./icon_home_aiedit_filter--actived.png": 26406,
	"./icon_home_aiedit_filter.png": 96902,
	"./icon_home_aiedit_imageUpgrade--actived.png": 54317,
	"./icon_home_aiedit_imageUpgrade.png": 18184,
	"./icon_home_aiedit_magicErase--actived.png": 97078,
	"./icon_home_aiedit_magicErase.png": 9566,
	"./icon_home_aiedit_matting--actived.png": 87780,
	"./icon_home_aiedit_matting.png": 82418,
	"./icon_home_clothes--actived.png": 3914,
	"./icon_home_clothes.png": 13947,
	"./icon_home_commodity--actived.png": 22922,
	"./icon_home_commodity.png": 65197,
	"./icon_home_dressform--actived.png": 91627,
	"./icon_home_dressform.png": 36236,
	"./icon_home_model--actived.png": 99025,
	"./icon_home_model.png": 94734,
	"./icon_home_modelvideo--actived.png": 96735,
	"./icon_home_modelvideo.png": 76965,
	"./icon_home_shoes--actived.png": 40686,
	"./icon_home_shoes.png": 90980,
	"./icon_imageUpgrade.svg": 41646,
	"./icon_imageUpgrade_actived.svg": 84698,
	"./icon_imageUpgrade_hover.svg": 38828,
	"./icon_left_arrow.svg": 3049,
	"./icon_light.svg": 65053,
	"./icon_light_actived.svg": 78318,
	"./icon_light_hover.svg": 17595,
	"./icon_locked.svg": 27330,
	"./icon_magicErase.svg": 29326,
	"./icon_magicErase_actived.svg": 58735,
	"./icon_magicErase_hover.svg": 53557,
	"./icon_matting_btn.svg": 53329,
	"./icon_matting_btn2.svg": 26986,
	"./icon_mobility.png": 22886,
	"./icon_mobility_select.png": 49648,
	"./icon_model.png": 50107,
	"./icon_model.svg": 5868,
	"./icon_model_actived.png": 3822,
	"./icon_more_arrow.svg": 78319,
	"./icon_more_checked.svg": 91211,
	"./icon_mouse_right.svg": 48188,
	"./icon_mouse_wheel.svg": 31407,
	"./icon_new.svg": 73592,
	"./icon_next level_hover@2x.png": 18944,
	"./icon_next level_normal@2x.png": 6002,
	"./icon_order.png": 73674,
	"./icon_paint.svg": 17278,
	"./icon_paint_actived.svg": 50776,
	"./icon_personal center.png": 96988,
	"./icon_phone.png": 33805,
	"./icon_phone.svg": 99210,
	"./icon_private.svg": 35884,
	"./icon_projects.png": 69606,
	"./icon_projects_actived.png": 8217,
	"./icon_prompt.png": 2901,
	"./icon_question.svg": 76775,
	"./icon_question_hover.svg": 68488,
	"./icon_rebate.svg": 16737,
	"./icon_recharge.png": 52886,
	"./icon_remove.svg": 13870,
	"./icon_rename.svg": 46252,
	"./icon_rename_hover.svg": 18772,
	"./icon_rename_press.svg": 9547,
	"./icon_replica.svg": 97761,
	"./icon_replica_hover.svg": 1809,
	"./icon_replica_press.svg": 88838,
	"./icon_reset.svg": 9902,
	"./icon_reset_actived.svg": 45645,
	"./icon_rollback.svg": 56899,
	"./icon_satisfaction_bad.png": 36552,
	"./icon_satisfaction_good.png": 48429,
	"./icon_satisfaction_normal.png": 76878,
	"./icon_select.jpg": 93540,
	"./icon_send.svg": 64854,
	"./icon_send_hover.svg": 58245,
	"./icon_send_press.svg": 65695,
	"./icon_shapeShift.svg": 69082,
	"./icon_shapeShift_actived.svg": 49114,
	"./icon_shapeShift_hover.svg": 19142,
	"./icon_share.svg": 89340,
	"./icon_share_hover.svg": 2878,
	"./icon_share_press.svg": 80798,
	"./icon_shoes.png": 85982,
	"./icon_shoes_actived.png": 74098,
	"./icon_space_key_mouse_left.svg": 93033,
	"./icon_tasklist.png": 47131,
	"./icon_tasklist_hover.png": 53979,
	"./icon_tips.svg": 6193,
	"./icon_tutorials_normal.svg": 6819,
	"./icon_tutorials_selected.svg": 66793,
	"./icon_undo.svg": 83694,
	"./icon_undo_actived.svg": 30077,
	"./icon_unlock.svg": 77502,
	"./icon_upload_blue.svg": 410,
	"./icon_upload_white.svg": 96729,
	"./icon_upper class_hover.png": 48899,
	"./icon_upper class_normal.png": 42942,
	"./icon_upper class_normal@2x.png": 43073,
	"./icon_upper class_press@2x.png": 13615,
	"./icon_used.svg": 82745,
	"./icon_validation.svg": 75232,
	"./icon_vertical_normal@2x.png": 8570,
	"./icon_video.svg": 19972,
	"./icon_vip_max.svg": 63197,
	"./icon_vip_pro.svg": 90764,
	"./icon_vip_stand.svg": 75635,
	"./icon_vip_ultra.svg": 23894,
	"./icon_warning.svg": 29215,
	"./icon_watermark.png": 52189,
	"./icon_wxpay.png": 32755,
	"./icon_wxpay@2x.png": 27409,
	"./icon_wxpay@3x.png": 2917,
	"./imageResize/2times.png": 12865,
	"./imageResize/2times_active.png": 77708,
	"./imageResize/4times.png": 46485,
	"./imageResize/4times_active.png": 80062,
	"./imageResize/ResolutionSelectionIcon.png": 53243,
	"./imageResize/complete.png": 12453,
	"./imageResize/complete_active.png": 97873,
	"./imageResize/cutting.png": 43262,
	"./imageResize/cutting_active.png": 86912,
	"./imageResize/personPhoto.png": 37477,
	"./imageResize/personPhoto_active.png": 60729,
	"./imageResize/suggest1.png": 87037,
	"./imageResize/suggest10.png": 19689,
	"./imageResize/suggest11.png": 18963,
	"./imageResize/suggest12.png": 16834,
	"./imageResize/suggest2.png": 83378,
	"./imageResize/suggest3.png": 11386,
	"./imageResize/suggest4.png": 86462,
	"./imageResize/suggest5.png": 43628,
	"./imageResize/suggest6.png": 87581,
	"./imageResize/suggest7.png": 21107,
	"./imageResize/suggest8.png": 52003,
	"./imageResize/suggest9.png": 23625,
	"./imageResize/taobao1x1.png": 86841,
	"./imageResize/taobao1x1_active.png": 94295,
	"./imageResize/taobao3x4.png": 52530,
	"./imageResize/taobao3x4_active.png": 6239,
	"./incorrect (1).png": 64579,
	"./incorrect.png": 8182,
	"./incorrect.svg": 92377,
	"./left_flip.svg": 8583,
	"./left_flip_disabled.svg": 42874,
	"./light.png": 98030,
	"./login_left.webp": 57253,
	"./logo.svg": 82835,
	"./logo01.png": 71412,
	"./logo_121x75.svg": 73816,
	"./logo_cl.svg": 23069,
	"./logo_cloth.png": 8271,
	"./logo_mc.png": 82178,
	"./logo_mc.svg": 49999,
	"./mannequin_normal.png": 752,
	"./medals.svg": 56206,
	"./mobile_loginL.svg": 30294,
	"./mobile_logo.svg": 68961,
	"./mobile_scan_top@2x.png": 69808,
	"./more (1).svg": 84859,
	"./more.svg": 13201,
	"./more_normal.png": 85433,
	"./more_normal@2x.png": 21109,
	"./new.png": 32718,
	"./new@2x.png": 37840,
	"./new_oldest.png": 52252,
	"./new_oldest@2x.png": 52351,
	"./non-positive.png": 8430,
	"./nullpage.png": 48898,
	"./original@2x.png": 90446,
	"./outfits_background.png": 47430,
	"./p2_dressform.png": 8852,
	"./p2_model.png": 81216,
	"./p2_tryon.png": 76443,
	"./p2_tryon_icon.png": 73351,
	"./payBg.svg": 17567,
	"./pen_1.png": 35705,
	"./pen_2.png": 71645,
	"./pendding.png": 95883,
	"./photostudio.svg": 95300,
	"./planicon1.png": 2924,
	"./planicon2.png": 14601,
	"./planicon3.png": 57811,
	"./planicon4.png": 35417,
	"./planicon5.png": 82461,
	"./plans_bg_basic.svg": 85138,
	"./plans_bg_professional.svg": 35710,
	"./plans_bg_ultimate.svg": 26063,
	"./positively.png": 92973,
	"./preview/icon-arrow-right.svg": 92002,
	"./preview/icon-arrow-right_hover.svg": 10357,
	"./preview/icon-close.svg": 30153,
	"./preview/icon-ding.svg": 6006,
	"./preview/icon-download.svg": 54846,
	"./preview/icon-feedback.svg": 97161,
	"./preview/icon-feedback_active.svg": 68817,
	"./preview/icon-huabi.svg": 66913,
	"./preview/icon-huabi_hover.svg": 1204,
	"./preview/icon-kuangxuan.svg": 75591,
	"./preview/icon-kuangxuan_hover.svg": 2241,
	"./preview/icon-move.svg": 3869,
	"./preview/icon-multi-images.png": 29428,
	"./preview/icon-multi-images.svg": 31584,
	"./preview/icon-multi-images_hover.png": 89939,
	"./preview/icon-multi-images_hover.svg": 37884,
	"./preview/icon-quanxuan.svg": 4310,
	"./preview/icon-quanxuan_hover.svg": 15,
	"./preview/icon-single-image.png": 90109,
	"./preview/icon-single-image.svg": 20735,
	"./preview/icon-single-image_hover.png": 14007,
	"./preview/icon-single-image_hover.svg": 28879,
	"./preview/icon-text.svg": 89007,
	"./preview/icon-text_hover.svg": 26534,
	"./qrcode.png": 77869,
	"./qrcode2.png": 10940,
	"./recharge_frame.svg": 61536,
	"./rect_1.png": 23039,
	"./rect_2.png": 5177,
	"./refused.png": 74767,
	"./reset_btn.png": 15045,
	"./reset_btn.svg": 85690,
	"./right_flip.svg": 15944,
	"./right_flip_disabled.svg": 26484,
	"./share.svg": 64459,
	"./share_dark.svg": 75243,
	"./share_dark_hover.svg": 23353,
	"./share_dark_press.svg": 36310,
	"./share_hover.svg": 46714,
	"./share_press.svg": 21767,
	"./shelter from.png": 66022,
	"./silhouette_pants.png": 37110,
	"./silhouette_skirt.png": 8255,
	"./silhouette_top.png": 5325,
	"./status_0.png": 4818,
	"./status_1.png": 99390,
	"./status_2.png": 9402,
	"./status_3.png": 15191,
	"./svgIcon/Alipay.svg": 6130,
	"./svgIcon/LimitedTimeIcon.svg": 70366,
	"./svgIcon/LoggedAvatarFree.svg": 42072,
	"./svgIcon/LoggedAvatarMax.svg": 62207,
	"./svgIcon/LoggedAvatarPopoverBg0.svg": 9690,
	"./svgIcon/LoggedAvatarPopoverBg1.svg": 84137,
	"./svgIcon/LoggedAvatarPopoverBg2.svg": 47823,
	"./svgIcon/LoggedAvatarPopoverBg3.svg": 24752,
	"./svgIcon/LoggedAvatarPopoverBg4.svg": 92432,
	"./svgIcon/LoggedAvatarPopoverDiamond1.svg": 28381,
	"./svgIcon/LoggedAvatarPopoverDiamond2.svg": 25775,
	"./svgIcon/LoggedAvatarPopoverDiamond3.svg": 4582,
	"./svgIcon/LoggedAvatarPopoverDiamond4.svg": 37206,
	"./svgIcon/LoggedAvatarPro.svg": 94277,
	"./svgIcon/LoggedAvatarUltra.svg": 42412,
	"./svgIcon/arcbeanFilled.svg": 50334,
	"./svgIcon/bestsellerIcon.svg": 53089,
	"./svgIcon/changeIcon.svg": 90709,
	"./svgIcon/customizeIcon.svg": 5572,
	"./svgIcon/freeIcon.svg": 99332,
	"./svgIcon/markIcon.svg": 85988,
	"./svgIcon/memberIcon.svg": 11765,
	"./svgIcon/memberOutlined.svg": 13034,
	"./svgIcon/pay_bg_1.svg": 89499,
	"./svgIcon/pay_bg_2.svg": 97757,
	"./svgIcon/pay_bg_3.svg": 70320,
	"./svgIcon/personSliderTopbg.png": 71731,
	"./svgIcon/personSliderTopbg.svg": 25260,
	"./svgIcon/personalOutlined.svg": 61524,
	"./svgIcon/seatOutlined.svg": 87197,
	"./svgIcon/teamOutlined.svg": 42716,
	"./svgIcon/unarcbeanFilled.svg": 57654,
	"./svgIcon/vipIcon.svg": 16384,
	"./svgIcon/wechat.svg": 45658,
	"./tab_bg_left.svg": 74097,
	"./tab_bg_middle.svg": 16892,
	"./tab_bg_right.svg": 19334,
	"./tab_bg_side.svg": 82416,
	"./tag_bg_left.svg": 480,
	"./tag_bg_middle.svg": 99416,
	"./template.docx": 89089,
	"./time_corner.svg": 26781,
	"./tip_hover.svg": 28574,
	"./tip_normal.svg": 36612,
	"./tobeConfirm.png": 99258,
	"./toggle_Toggle_Left_Right.svg": 6978,
	"./toggle_Toggle_Right_Left.svg": 79175,
	"./totalPrice_icon.png": 44523,
	"./unwearable fold.png": 90253,
	"./uploadAdd.png": 56235,
	"./uploadAdd2.png": 27285,
	"./vip_conner.png": 23186,
	"./vip_conner.svg": 44275,
	"./vip_required.svg": 33892,
	"./waitEdit.png": 25610,
	"./waitSelectPic.png": 12856,
	"./waitSelectPic.svg": 14113,
	"./waitdelivery.png": 86988,
	"./waitps.png": 51390,
	"./watermarks.png": 57131,
	"./watermarks.svg": 65089,
	"./wechat1.png": 78792,
	"./wechat2.png": 62444,
	"./虹软科技-ArcMuse计算技术引擎动态周报20240717-20240723.docx": 97511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;